module.exports = __webpack_public_path__ + "img/editors.4d6b66bd.png";